var _polygon;
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "21.8994949 3.51471863 13.4142136 12 21.8994949 20.4852814 20.4852814 21.8994949 12 13.4142136 3.51471863 21.8994949 2.10050506 20.4852814 10.5857864 12 2.10050506 3.51471863 3.51471863 2.10050506 12 10.5857864 20.4852814 2.10050506"
  }));
};
export default SvgClose;